
document.addEventListener('DOMContentLoaded', () => {
 
  if (!document.getElementById('nguBuscar')) return;
 
  /* ── Idioma activo de la tienda ──
     En tu HTML/Liquid, añade el atributo data-locale al botón, así:
       <button id="nguBuscar" data-locale="{{ request.locale.iso_code }}">...</button>
     Shopify rellenará ese atributo con "es", "en", "es-ES", "en-US", etc.
     según el idioma activo de la tienda para cada visitante. */
  const rawLocale = (document.getElementById('nguBuscar').dataset.locale || 'es').toLowerCase();
  const lang = rawLocale.startsWith('en') ? 'en' : 'es';
 
  /* ── Diccionario de textos ── */
  const I18N = {
    es: {
      invalidCert: 'Introduce un número de certificado válido.',
      loading: 'Consultando certificado…',
      notFound: 'No se encontró información para ese certificado.',
      sectionFicha: 'FICHA PRODUCTO',
      labelCertificado: 'Certificado',
      labelAno: 'Año',
      labelCarta: 'Carta',
      labelColeccion: 'Colección',
      labelSet: 'Set',
      labelIdiomaId: 'Idioma / Nº #ID',
      labelVariante: 'Variante',
      labelFechaGrading: 'Fecha Grading',
      subgradesTitle: 'SUB-GRADOS',
      noSubgrades: 'Sin subgrades',
      hexLabel: 'NOTA',
      sectionPoblacion: 'POBLACIÓN',
      popSameGrade: 'En este grado',
      popHigherGrades: 'Grados superiores',
      popTotal: 'Total población',
      topPop: '🏆 Top Population',
      rankingTitle: 'RANKING',
    },
    en: {
      invalidCert: 'Enter a valid certificate number.',
      loading: 'Looking up certificate…',
      notFound: 'No information was found for that certificate.',
      sectionFicha: 'PRODUCT DETAILS',
      labelCertificado: 'Certificate',
      labelAno: 'Year',
      labelCarta: 'Card',
      labelColeccion: 'Collection',
      labelSet: 'Set',
      labelIdiomaId: 'Language / #ID',
      labelVariante: 'Variant',
      labelFechaGrading: 'Grading Date',
      subgradesTitle: 'SUB-GRADES',
      noSubgrades: 'No subgrades',
      hexLabel: 'GRADE',
      sectionPoblacion: 'POPULATION',
      popSameGrade: 'In this grade',
      popHigherGrades: 'Higher grades',
      popTotal: 'Total population',
      topPop: '🏆 Top Population',
      rankingTitle: 'RANKING',
    },
  };
  const t = I18N[lang];
 
  /* ── Inyectar estilos ── */
  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=IBM+Plex+Sans:wght@300;400;500;600&display=swap');
 
    .ngu-card-result {
      max-width: 600px;
      font-family: 'IBM Plex Sans', sans-serif;
      color: #e8e8e8;
      animation: nguFadeIn .4s ease;
    }
    @keyframes nguFadeIn {
      from { opacity:0; transform:translateY(12px); }
      to   { opacity:1; transform:translateY(0); }
    }
 
    .ngu-section-title {
      font-family: 'Bebas Neue', sans-serif;
      font-size: 26px;
      letter-spacing: 3px;
      color: #fff200;
      margin-bottom: 16px;
    }
 
    /* Ficha grid */
    .ngu-ficha-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 28px;
      padding: 0 24px;
    }
    .ngu-ficha-item {
      padding: 10px 0;
      border-bottom: 1px solid #2a2a2a;
    }
    .ngu-ficha-item:nth-child(odd) { padding-right: 20px; }
    .ngu-ficha-item:nth-child(even) { padding-left: 20px; }
    .ngu-ficha-label {
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      color: #777;
      margin-bottom: 2px;
    }
    .ngu-ficha-value {
      font-size: 15px;
      font-weight: 500;
      color: #fff;
    }
 
    /* Sub-grados box */
    .ngu-subgrades-box {
      border: 1px solid #2a2a2a;
      padding: 24px;
      display: flex;
      gap: 24px;
      align-items: center;
      margin-bottom: 28px;
    }
    .ngu-subgrades-left { flex: 1; }
    .ngu-subgrades-left h4 {
      font-family: 'Bebas Neue', sans-serif;
      font-size: 26px;
      letter-spacing: 3px;
      color: #fff200;
      margin-bottom: 12px;
    }
    .ngu-sub-item {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      border-bottom: 1px solid #2a2a2a;
      font-size: 14px;
    }
    .ngu-sub-item:last-child { border-bottom: none; }
    .ngu-sub-name { color: #777; }
    .ngu-sub-val  { color: #fff; font-weight: 600; }
 
    /* Hexágono */
    .ngu-hex-wrap {
      flex-shrink: 0;
      width: 120px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .ngu-hex-outer {
      position: relative;
      width: 110px;
      height: 127px;
    }
    .ngu-hex-outer::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0.08));
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    }
    .ngu-hex-inner {
      position: absolute;
      top: 3px; left: 3px; right: 3px; bottom: 3px;
      background:
        radial-gradient(ellipse at 50% 30%, rgba(80,80,80,0.5), transparent 60%),
        linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 100%);
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .ngu-hex-inner::before {
      content: '';
      position: absolute;
      width: 80%; height: 80%;
      border: 1px solid rgba(255,255,255,0.06);
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    }
    .ngu-hex-inner::after {
      content: '';
      position: absolute;
      width: 60%; height: 60%;
      border: 1px solid rgba(255,255,255,0.04);
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    }
    .ngu-hex-label {
      font-family: 'Bebas Neue', sans-serif;
      font-size: 13px;
      letter-spacing: 2px;
      color: #777;
      position: relative;
      z-index: 1;
      margin-bottom: 2px;
    }
    .ngu-hex-grade {
      font-family: 'Bebas Neue', sans-serif;
      font-size: 36px;
      color: #fff200;
      line-height: 1;
      position: relative;
      z-index: 1;
    }
    .ngu-hex-grade-label {
      font-size: 11px;
      color: #fff200;
      letter-spacing: 1px;
      margin-top: 6px;
      text-align: center;
      font-weight: 500;
    }
 
    /* Población + Ranking wrapper */
    .ngu-pop-ranking-wrap {
      display: flex;
      gap: 24px;
      align-items: flex-start;
      margin-bottom: 28px;
      padding: 0 24px;
    }
    .ngu-pop-section { flex: 1; }
   .ngu-pop-item {
      padding: 8px 0;
      border-bottom: 1px solid #2a2a2a;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      font-size: 14px;
    }
    .ngu-pop-item:last-child { border-bottom: none; }
    .ngu-pop-label {
      color: #777;
      flex: 1;
      min-width: 0;
    }
    .ngu-pop-val {
      color: #fff;
      font-weight: 600;
      flex-shrink: 0;
      white-space: nowrap;
    }
    .ngu-top-pop {
      display: inline-block;
      margin-top: 8px;
      font-size: 13px;
      color: #d4af37;
      font-weight: 600;
    }
 
    /* Ranking */
    .ngu-ranking {
      flex-shrink: 0;
      width: 120px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    .ngu-ranking h4 {
      font-family: 'Bebas Neue', sans-serif;
      font-size: 26px;
      letter-spacing: 3px;
      color: #fff200;
      margin-bottom: 8px;
    }
    .ngu-ranking-pos {
      font-family: 'Bebas Neue', sans-serif;
      font-size: 42px;
      color: #fff;
      line-height: 1;
    }
    .ngu-ranking-pos sup {
      font-size: 18px;
    }
 
    /* Imágenes */
    .ngu-images {
      display: flex;
      gap: 12px;
      margin-bottom: 20px;
    }
    .ngu-images img {
      max-width: 48%;
      border: 1px solid #2a2a2a;
      border-radius: 2px;
    }
 
    .ngu-date {
      font-size: 12px;
      color: #777;
      margin-top: 8px;
    }
 
    .ngu-loading {
      color: #777;
      animation: nguPulse 1.2s infinite;
    }
    @keyframes nguPulse { 0%,100%{opacity:.4} 50%{opacity:1} }
 
    @media (max-width: 500px) {
      .ngu-ficha-grid { grid-template-columns: 1fr; }
      .ngu-ficha-item:nth-child(even) { padding-left: 0 !important; }
      .ngu-subgrades-box { flex-direction: column; }
      .ngu-hex-wrap { margin-top: 16px; }
      .ngu-pop-ranking-wrap { flex-direction: column; }
      .ngu-ranking { margin-top: 16px; }
    }
  `;
  document.head.appendChild(style);
 
  /* ── Lógica ── */
  const btn = document.getElementById('nguBuscar');
  const input = document.getElementById('nguSerial');
  const resultado = document.getElementById('nguResultado');
 
  input.value = '#';
  input.addEventListener('input', () => {
    if (!input.value.startsWith('#')) {
      input.value = '#' + input.value.replace(/#/g, '');
    }
  });
 
  btn.addEventListener('click', () => {
    const serial = input.value.replace('#', '').trim();
 
    if (!serial) {
      resultado.innerHTML = `<p style="color:#777;">${t.invalidCert}</p>`;
      return;
    }
 
    resultado.innerHTML = `<p class="ngu-loading">${t.loading}</p>`;
 
    fetch('https://dev-back.nextgrading.com/api/certificates/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ certificateNumber: serial })
    })
    .then(res => {
      if (!res.ok) throw new Error('No encontrado');
      return res.json();
    })
    .then(data => {
      resultado.innerHTML = renderResultado(data);
    })
    .catch(() => {
      resultado.innerHTML = `<p style="color:#777; text-align:center">${t.notFound}</p>`;
    });
  });
 
  function renderResultado(data) {
    const grade = data.grade ?? '—';
    const gradeLabel = data.gradeLabel ?? '';
 
    /* Helper: mostrar con decimal */
    const dec = (v) => v != null ? Number(v).toFixed(1) : null;
 
    /* Sub-grados: orden CORNERS → EDGES → CENTERING → SURFACES
       (se mantienen en inglés porque son términos técnicos estándar
       del sector de grading, igual que "grade" o "PSA/BGS") */
    const subEntries = data.subgrades
      ? [
          { name: 'CORNERS',   val: dec(data.subgrades.corners) },
          { name: 'EDGES',     val: dec(data.subgrades.edges) },
          { name: 'CENTERING', val: dec(data.subgrades.centering) },
          { name: 'SURFACES',  val: dec(data.subgrades.surfaces) },
        ].filter(s => s.val != null)
      : [];
 
    const subItems = subEntries.length
      ? subEntries.map(s => `<div class="ngu-sub-item"><span class="ngu-sub-name">${s.name}</span><span class="ngu-sub-val">${s.val}</span></div>`).join('')
      : `<p style="color:#777;font-size:14px;">${t.noSubgrades}</p>`;
 
    /* Imágenes */
    const images = (data.images?.front || data.images?.graded)
      ? `<div class="ngu-images">
           ${data.images.front  ? `<img src="${data.images.front}" alt="Card front">` : ''}
           ${data.images.graded ? `<img src="${data.images.graded}" alt="Graded slab">` : ''}
         </div>`
      : '';
 
    /* Población total */
    const totalPop = data.population?.distribution
      ? data.population.distribution.reduce((sum, d) => sum + (d.count || 0), 0)
      : null;
 
    /* Ranking */
    const ranking = data.population?.inHigherGrades != null
      ? data.population.inHigherGrades + 1
      : null;
 
    /* Ficha: idioma + nº id combinado, fecha grading */
    const idiomaId = [data.language, data.cardNumber ? `#${data.cardNumber}` : null].filter(Boolean).join(' / ') || null;
    const gradedDateStr = data.gradedDate ? new Date(data.gradedDate).toLocaleDateString(lang === 'en' ? 'en-US' : 'es-ES') : null;
 
    /* Construir ficha producto — solo campos con dato */
    const fichaFields = [
      { label: t.labelCertificado, value: data.certificateNumber ? `#${data.certificateNumber}` : null },
      { label: t.labelAno, value: data.year ?? null },
      { label: t.labelCarta, value: data.cardName ?? null },
      { label: t.labelColeccion, value: data.game ?? null },
      { label: t.labelSet, value: data.cardSet ?? null },
      { label: t.labelIdiomaId, value: idiomaId },
      { label: t.labelVariante, value: data.variant?.trim() || null },
      { label: t.labelFechaGrading, value: gradedDateStr },
    ].filter(f => f.value != null);
 
    const fichaHtml = fichaFields.map(f => `
      <div class="ngu-ficha-item">
        <div class="ngu-ficha-label">${f.label}</div>
        <div class="ngu-ficha-value">${f.value}</div>
      </div>
    `).join('');
 
    /* Población items */
    let popHtml = '';
    if (data.population) {
      if (data.population.inSameGrade != null)
        popHtml += `<div class="ngu-pop-item"><span class="ngu-pop-label">${t.popSameGrade}</span><span class="ngu-pop-val">${data.population.inSameGrade}</span></div>`;
      if (data.population.inHigherGrades != null)
        popHtml += `<div class="ngu-pop-item"><span class="ngu-pop-label">${t.popHigherGrades}</span><span class="ngu-pop-val">${data.population.inHigherGrades}</span></div>`;
      if (totalPop != null)
        popHtml += `<div class="ngu-pop-item"><span class="ngu-pop-label">${t.popTotal}</span><span class="ngu-pop-val">${totalPop}</span></div>`;
    }
 
    /* Ranking HTML */
    const rankingHtml = ranking != null
      ? `<div class="ngu-ranking">
           <h4>${t.rankingTitle}</h4>
           <div class="ngu-ranking-pos">${ranking}<sup>º</sup></div>
         </div>`
      : '';
 
    return `
      <div class="ngu-card-result">
 
        <h2 class="ngu-section-title" style="padding-left:24px">${t.sectionFicha}</h2>
        <div class="ngu-ficha-grid">
          ${fichaHtml}
        </div>
 
        <div class="ngu-subgrades-box">
          <div class="ngu-subgrades-left">
            <h4>${t.subgradesTitle}</h4>
            ${subItems}
          </div>
          <div class="ngu-hex-wrap">
            <div class="ngu-hex-outer">
              <div class="ngu-hex-inner">
                <span class="ngu-hex-label">${t.hexLabel}</span>
                <span class="ngu-hex-grade">${grade}</span>
              </div>
            </div>
            ${gradeLabel ? `<span class="ngu-hex-grade-label">${gradeLabel}</span>` : ''}
          </div>
        </div>
 
        ${data.population ? `
        <div class="ngu-pop-ranking-wrap">
          <div class="ngu-pop-section">
            <h2 class="ngu-section-title">${t.sectionPoblacion}</h2>
            ${popHtml}
            ${data.population.isTopPop ? `<span class="ngu-top-pop">${t.topPop}</span>` : ''}
          </div>
          ${rankingHtml}
        </div>
        ` : ''}
 
        ${images}
 
      </div>
    `;
  }
 
});
 

